module.exports = __webpack_public_path__ + "static/media/nature_icon_store.affa8589.png";